import axios from '../axios'
import { errorMessage, fieldErrors } from './FollowupService'

/**
 * Stage 1, two-way Outlook (DESIGN-outlook-two-way-stage1-2026-10-26 §2a): what Outlook may change in the CRM,
 * and how the sync is going for a user or an activity.
 *
 * A refusal is a 409 `{ error }`, never a 403 (the global axios interceptor signs the user out on any 403);
 * a bad key or value is a 400 `{ error, errors: { key: message } }`.
 */
export default class OutlookSyncService {
  /** The ten switches and tieSeconds (read-only). Any signed-in user. */
  getSettings() {
    return axios.get('/v1/outlookSyncSettings').then(response => response.data)
  }

  /** Admin only. Any subset of the ten switches; answers with the same body as getSettings. */
  saveSettings(settings) {
    return axios.put('/v1/outlookSyncSettings', settings).then(response => response.data)
  }

  /** `{ calendar, todo, serverSync }` for one user: an Admin for anyone, a user for themselves (409 otherwise). */
  userStatus(userId) {
    return axios.get('/v1/outlookSyncStatus/user/' + userId).then(response => response.data)
  }

  /** `{ target, status, syncedAt, message }` for one task or event (404 when there is nothing to say). */
  activityStatus(activityId) {
    return axios.get('/v1/activity/' + activityId + '/outlookSync').then(response => response.data)
  }
}

export { errorMessage, fieldErrors }
